import CampusStipendBrochure from "./CampusStipendBrochure"

export default function CampusBrochureKIIT() {
    return <CampusStipendBrochure college="KIIT Bhubaneswar" eligibility="2nd or 3rd-year undergrad" campus="kiit" />
}
